import { render, staticRenderFns } from "./QuestionInputNumber.vue?vue&type=template&id=65f2d272&scoped=true&"
import script from "./QuestionInputNumber.vue?vue&type=script&lang=js&"
export * from "./QuestionInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f2d272",
  null
  
)

export default component.exports